import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
pdfMake.vfs = pdfFonts.vfs;
const PaymentHistory = () => {
    const [activeTab, setActiveTab] = useState("pending");

    const activeToggle = (tab) => {
        setActiveTab(tab);
    };

    const table1 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12;

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }


        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Financials</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Financials</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card radius-10">
                        <div className="entries-wrapper mb-3">
                            <label className="entries-label">
                                <span>Showing</span>
                                <select className="entries-select">
                                    <option value={10} selected>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                                <span>Entries</span>
                            </label>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-striped table-bordered align-middle text-center mb-0" ref={table1}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>Subscription Plan</th>
                                            <th>Amount Paid</th>
                                            <th>Purchase Date</th>
                                            <th>Expiry Date</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Row 1 */}
                                        <tr>
                                            <td>John</td>
                                            <td>Smith</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Basic</option>
                                                </select>
                                            </td>
                                            <td>$50.00</td>
                                            <td>Jan 15, 2025</td>
                                            <td>Jan 15, 2026</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Active</option>
                                                </select>
                                            </td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0 justify-content-center">
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#viewpayinModal" title="View">
                                                            <i className="lni lni-eye" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        {/* Row 2 */}
                                        <tr>
                                            <td>Maria</td>
                                            <td>Lopez</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Premium</option>
                                                </select>
                                            </td>
                                            <td>$30.00</td>
                                            <td>Feb 05, 2026</td>
                                            <td>Mar 05, 2026</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Expired</option>
                                                </select>
                                            </td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0 justify-content-center">
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#viewpayinModal" title="View">
                                                            <i className="lni lni-eye" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        {/* Row 3 */}
                                        <tr>
                                            <td>Michael</td>
                                            <td>Brown</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Basic</option>
                                                </select>
                                            </td>
                                            <td>$40.00</td>
                                            <td>Apr 01, 2026</td>
                                            <td>Apr 01, 2026</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Active</option>
                                                </select>
                                            </td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0 justify-content-center">
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#viewpayinModal" title="View">
                                                            <i className="lni lni-eye" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        {/* Row 4 */}
                                        <tr>
                                            <td>Emily</td>
                                            <td>Johnson</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Premium</option>
                                                </select>
                                            </td>
                                            <td>$60.00</td>
                                            <td>Mar 10, 2026</td>
                                            <td>Mar 10, 2026</td>
                                            <td>
                                                <select className="status-select" disabled>
                                                    <option selected>Active</option>
                                                </select>
                                            </td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0 justify-content-center">
                                                    <li>
                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#viewpayinModal" title="View">
                                                            <i className="lni lni-eye" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="viewpayinModal" tabIndex={-1}>
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Payment Information</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <div className="row mb-3 align-items-center">
                                <div className="col-sm-3"><h6 className="mb-0">First Name</h6></div>
                                <div className="col-sm-9"><input type="text" className="form-control" readOnly defaultValue="John" /></div>
                            </div>
                            <div className="row mb-3 align-items-center">
                                <div className="col-sm-3"><h6 className="mb-0">Last Name</h6></div>
                                <div className="col-sm-9"><input type="text" className="form-control" readOnly defaultValue="Smith" /></div>
                            </div>
                            <div className="row mb-3 align-items-center">
                                <div className="col-sm-3"><h6 className="mb-0">Amount Paid</h6></div>
                                <div className="col-sm-9"><input type="text" className="form-control" readOnly defaultValue="$50.00" /></div>
                            </div>
                            <div className="row mb-3 align-items-center">
                                <div className="col-sm-3"><h6 className="mb-0">Subscription Plan</h6></div>
                                <div className="col-sm-9"><input type="text" className="form-control" readOnly defaultValue="Basic" /></div>
                            </div>
                            <div className="row mb-3 align-items-center">
                                <div className="col-sm-3"><h6 className="mb-0">Purchase Date</h6></div>
                                <div className="col-sm-9"><input type="text" className="form-control" readOnly defaultValue="Feb 05, 2026" /></div>
                            </div>
                            <div className="row mb-3 align-items-center">
                                <div className="col-sm-3"><h6 className="mb-0">Expiry Date</h6></div>
                                <div className="col-sm-9"><input type="text" className="form-control" readOnly defaultValue="Apr 01, 2026" /></div>
                            </div>
                            <div className="row mb-3 align-items-center">
                                <div className="col-sm-3"><h6 className="mb-0">Status</h6></div>
                                <div className="col-sm-9"><input type="text" className="form-control" readOnly defaultValue="Active" /></div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default PaymentHistory